import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = (props) => {
    const {height, overlay = true} = props;
    const containerStyle = overlay
        ? {
            position: 'fixed',
            left: 0,
            top: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            background: 'rgba(255,255,255,0.6)'
        }
        : {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '100vh',
            height: `${height === undefined ? '80vh' : height}`
        };

    return (
        <div style={containerStyle}>
            <CircularProgress style={{ color: '#002376' }} size={40} />
        </div>
    );
}

Loader.propTypes = {
    height: PropTypes.string,
};

export default Loader;